export const isAmpliencePreviewEnabled = (): boolean => process.env.AMPLIENCE_PREVIEW_ENABLED === 'true';
